import React from 'react';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 8px 12px;
`;

const TooltipLabel = styled.p`
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px 0;
`;

const TooltipValue = styled.p`
  color: #2d3748;
  font-size: 14px;
  margin: 0;
`;

export function CustomTooltip({ active, payload, chartData }) {
  if (active && payload && payload.length) {
    const data = payload[0];
    const total = chartData.reduce((sum, item) => sum + item.value, 0);
    const percentage = total > 0 ? ((data.value / total) * 100).toFixed(1) : 0;

    return (
      <TooltipContainer>
        <TooltipLabel>{data.name}</TooltipLabel>
        <TooltipValue>
          {data.value} visit{data.value !== 1 ? 's' : ''} ({percentage}%)
        </TooltipValue>
      </TooltipContainer>
    );
  }
  return null;
}
